module.exports = __webpack_public_path__ + "media/images/available_on_the_app_store-064c7da172b657ee3e7ed50d3a07fda8.png";